import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppNotificationService } from '@shared/services';

/**
 * Guards redirect to the dashboard, so the user needs a reason for being moved.
 * Must be called from an injection context (i.e. directly inside a guard).
 *
 * The toast is deferred because a notification raised while the router is still
 * resolving the blocked route gets discarded before it can render.
 */
export const notifyAccessDenied = (): void => {
  const notificationService = inject(AppNotificationService);
  const translate = inject(TranslateService);

  const title = translate.instant('error-notifications.forbidden.title');
  const description = translate.instant(
    'error-notifications.forbidden.description'
  );

  setTimeout(() => notificationService.showTranslatedToast(title, description));
};
